import TargetAudiencePage from './TargetAudiencePage';
import type { AudienceContent } from './TargetAudiencePage';

const content: { hr: AudienceContent; en: AudienceContent } = {
  hr: {
    meta: { title: 'Za vlasnike vila | BookiApp', description: 'BookiApp za vlasnike vila i premium smještaja. Pružite 5-zvjezdično digitalno iskustvo gostima koji plaćaju premium cijenu.' },
    hero: { badge: 'ZA VILE', title: 'Premium smještaj zaslužuje', highlight: 'premium iskustvo.', subtitle: 'Gosti koji plaćaju 200 EUR+ po noći očekuju više od WhatsApp poruke. Dajte im profesionalnu aplikaciju koja odgovara kvaliteti vašeg smještaja.', image: '🏡' },
    painPoints: {
      title: 'Premium gosti očekuju više',
      items: [
        'Gosti plaćaju 200-500 EUR/noć ali dobivaju WhatsApp upute',
        'Hoteli imaju aplikacije, vi nemate - to gosti primijete',
        'Bazeni, jakuziji, roštilji - puno sadržaja za objasniti',
        'Gosti iz 10+ zemalja - jezična barijera je česta',
        'Jedna loša recenzija na premium vili košta puno više',
        'Želite se razlikovati od drugih vila u ponudi',
      ],
    },
    solutions: {
      title: 'Digitalno iskustvo za premium goste',
      subtitle: 'Vaša vila zaslužuje aplikaciju koja joj odgovara',
      items: [
        { icon: 'smartphone', title: 'Brendirana aplikacija', desc: 'Personalizirana aplikacija s imenom vaše vile. Profesionalni dojam od prvog kontakta.' },
        { icon: 'messages', title: 'VIP komunikacija', desc: 'Chat s prijevodom na 95+ jezika. Gost se osjeća kao da ima osobnog concierge-a.' },
        { icon: 'map', title: 'Kuratirane preporuke', desc: 'Vaši odabrani restorani, plaže, izleti. Osobni touch koji gosti pamte.' },
        { icon: 'bot', title: 'AI concierge 24/7', desc: 'AI odgovara na pitanja gostiju koristeći podatke o vašoj vili. Dostupan i u 3 ujutro.' },
        { icon: 'bell', title: 'Pametne obavijesti', desc: 'Obavijest kad gost krene, push za pravila bazena, podsjetnik za check-out.' },
        { icon: 'shield', title: 'Detaljne upute', desc: 'Kako koristiti bazen, jakuzi, roštilj, smart TV. Sve s slikama i na jeziku gosta.' },
      ],
    },
    stats: [
      { value: '69 EUR', label: 'godišnje (Early Adopter)' },
      { value: '1', label: 'loša recenzija manje' },
      { value: '5★', label: 'dojam na goste' },
      { value: '0', label: 'poziva u 23h' },
    ],
    cta: { title: 'Vaša vila zaslužuje najbolje', subtitle: 'Premium smještaj + premium iskustvo gosta = savršene recenzije.', button: 'Započni sada' },
  },
  en: {
    meta: { title: 'For villa owners | BookiApp', description: 'BookiApp for villa and premium accommodation owners. Provide a 5-star digital experience for guests paying premium prices.' },
    hero: { badge: 'FOR VILLAS', title: 'Premium accommodation deserves', highlight: 'a premium experience.', subtitle: 'Guests paying 200+ EUR per night expect more than a WhatsApp message. Give them a professional app that matches your property quality.', image: '🏡' },
    painPoints: {
      title: 'Premium guests expect more',
      items: [
        'Guests pay 200-500 EUR/night but get WhatsApp instructions',
        'Hotels have apps, you don\'t - guests notice that',
        'Pools, hot tubs, BBQs - lots of amenities to explain',
        'Guests from 10+ countries - language barrier is common',
        'One bad review on a premium villa costs much more',
        'You want to stand out from other villas on the market',
      ],
    },
    solutions: {
      title: 'Digital experience for premium guests',
      subtitle: 'Your villa deserves an app that matches it',
      items: [
        { icon: 'smartphone', title: 'Branded app', desc: 'Personalized app with your villa name. Professional impression from first contact.' },
        { icon: 'messages', title: 'VIP communication', desc: 'Chat with translation to 95+ languages. Guest feels like they have a personal concierge.' },
        { icon: 'map', title: 'Curated recommendations', desc: 'Your selected restaurants, beaches, excursions. Personal touch guests remember.' },
        { icon: 'bot', title: 'AI concierge 24/7', desc: 'AI answers guest questions using your villa data. Available even at 3 AM.' },
        { icon: 'bell', title: 'Smart notifications', desc: 'Notification when guest departs, push for pool rules, check-out reminder.' },
        { icon: 'shield', title: 'Detailed instructions', desc: 'How to use pool, hot tub, BBQ, smart TV. All with photos and in the guest\'s language.' },
      ],
    },
    stats: [
      { value: '69 EUR', label: 'per year (Early Adopter)' },
      { value: '1', label: 'fewer bad review' },
      { value: '5★', label: 'guest impression' },
      { value: '0', label: 'calls at 11 PM' },
    ],
    cta: { title: 'Your villa deserves the best', subtitle: 'Premium accommodation + premium guest experience = perfect reviews.', button: 'Get started' },
  },
};

export default function ZaVilePage() {
  return <TargetAudiencePage content={content} canonical="/za-vile" />;
}
